

// @mui material components
import Grid from "@mui/material/Grid";
import MDBox from "../../../../../components/MDBox";
import FormField from "../../../../../components/FormField";
import React from "react";
import MDTypography from "../../../../../components/MDTypography";
// Material Dashboard 2 PRO React components


function NewLocationForm({formData}) {

    const {formField, values, errors, touched} = formData;

    const {name, street, exterior_number, interior_number, suburb, postal_code, city, state} = formField;
    const {
        name: nameV,
        street: streetV,
        exterior_number: exteriorNumberV,
        interior_number: interiorNumberV,
        suburb: suburbV,
        postal_code: postalCodeV,
        city: cityV,
        state: stateV
    } = values;

    return (
        <MDBox>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={12}>
                    <FormField
                        type={name.type}
                        label={name.label}
                        name={name.name}
                        value={nameV}
                        error={errors.name && touched.name}
                        success={nameV && nameV.length > 0 && !errors.name}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <MDTypography variant="h6">Información de Dirección</MDTypography>
                    <MDTypography variant="body2">¿Dónde se ubica la sucursal?</MDTypography>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FormField
                        type={street.type}
                        label={street.label}
                        name={street.name}
                        value={streetV}
                        error={errors.street && touched.street}
                        success={streetV && streetV.length > 0 && !errors.street}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FormField
                        type={exterior_number.type}
                        label={exterior_number.label}
                        name={exterior_number.name}
                        value={exteriorNumberV}
                        error={errors.exterior_number && touched.exterior_number}
                        success={exteriorNumberV && exteriorNumberV.length > 0 && !errors.exterior_number}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FormField
                        type={interior_number.type}
                        label={interior_number.label}
                        name={interior_number.name}
                        value={interiorNumberV}
                        error={errors.interior_number && touched.interior_number}
                        success={interiorNumberV && interiorNumberV.length > 0 && !errors.interior_number}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormField
                        type={suburb.type}
                        label={suburb.label}
                        name={suburb.name}
                        value={suburbV}
                        error={errors.suburb && touched.suburb}
                        success={suburbV && suburbV.length > 0 && !errors.suburb}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormField
                        type={postal_code.type}
                        label={postal_code.label}
                        name={postal_code.name}
                        value={postalCodeV}
                        error={errors.postal_code && touched.postal_code}
                        success={postalCodeV && postalCodeV.length > 0 && !errors.postal_code}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <FormField
                        type={city.type}
                        label={city.label}
                        name={city.name}
                        value={cityV}
                        error={errors.city && touched.city}
                        success={cityV && cityV.length > 0 && !errors.city}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormField
                        type={state.type}
                        label={state.label}
                        name={state.name}
                        value={stateV}
                        error={errors.state && touched.state}
                        success={stateV && stateV.length > 0 && !errors.state}
                    />
                </Grid>
            </Grid>
        </MDBox>
    );
}

export default NewLocationForm;
